// Pure logica van Projecttaken (/mijn-taken): welke records tellen als taak, sortering en
// groepering per project. Los van de component, zodat het te testen is zonder scherm.
import { NIET_PRODUCTIE_SET } from '../../utils/taakStatus';
import { naarTaak, pasToe } from '../../ui-components/TaakPaneel/naarTaak';

export const ZONDER_PROJECT = 'Zonder project';
const PRIO_VOLGORDE = ['Prio 1', 'Prio 2', 'Prio 3', 'Prio 4', 'Deadline', 'Wacht op feedback', 'Geen prio'];

/** Ruw record uit /Api/my-tasks → rij. Het ruwe record reist mee voor het TaakPaneel. */
export function vanRecord(rec) {
  const t = naarTaak(rec);
  return { ...t, status: t.status || 'Geen prio', naam: t.naam || 'Naamloos', raw: rec };
}

/**
 * Kalenderblokken en afgeronde items zijn geen to-do (zelfde filter als Weekplan), en
 * vanallesuurtjes/focustijd/lunch op naam ook niet.
 */
export const isOpenstaand = (t) => !NIET_PRODUCTIE_SET.has(t.status) && !NIET_PRODUCTIE_SET.has(t.type)
  && !/vanallesuurtje|focustijd|dagstart|^lunch$/i.test(String(t.naam || '').trim());

export function sorteer(lijst, sortering = 'start') {
  if (sortering === 'prio') {
    const rang = (s) => { const i = PRIO_VOLGORDE.indexOf(s); return i < 0 ? PRIO_VOLGORDE.length : i; };
    return [...lijst].sort((a, b) => rang(a.status) - rang(b.status)
      || String(a.start || '9999').localeCompare(String(b.start || '9999')));
  }
  const sleutel = sortering === 'deadline' ? (t) => t.deadline || '9999' : (t) => t.start || '9999';
  return [...lijst].sort((a, b) => String(sleutel(a)).localeCompare(String(sleutel(b))));
}

/**
 * Per project: `[{ kop, projectId, taken, uren }]`, nieuwste projectnummer bovenaan en
 * "Zonder project" onderaan.
 */
export function groepeer(taken, sortering = 'start') {
  const per = new Map();
  (taken || []).forEach((t) => {
    const kop = t.projectNaam || ZONDER_PROJECT;
    if (!per.has(kop)) per.set(kop, { kop, projectId: t.projectId || null, taken: [] });
    per.get(kop).taken.push(t);
  });
  return [...per.values()]
    .map((g) => ({ ...g, taken: sorteer(g.taken, sortering), uren: g.taken.reduce((s, t) => s + (t.uren || 0), 0) }))
    .sort((a, b) => (a.kop === ZONDER_PROJECT) - (b.kop === ZONDER_PROJECT)
      || b.kop.localeCompare(a.kop, undefined, { numeric: true }));
}

/** Na een wijziging in het paneel: de rij (en het ruwe record) bijwerken. */
export function werkRijBij(rij, velden) {
  const raw = { ...rij.raw, fields: { ...(rij.raw?.fields || {}), ...velden } };
  return { ...pasToe(rij, velden), raw };
}

/** POST-body voor "+ taak toevoegen" in een projectgroep: jij bent de uitvoerder. */
export function nieuweTaakBody({ naam, projectId, email }) {
  return {
    NaamTaak: String(naam || '').trim(),
    PrioNr: 'Geen prio',
    ...(projectId ? { Project: [projectId] } : {}),
    ...(email ? { assigneeEmail: email } : {}),
  };
}

export const urenLabel = (n) => (n ? `${String(Math.round(n * 10) / 10).replace('.', ',')}u` : '');
